<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>留言地区统计</span>
    </div>
    <ve-pie
      :data="chartConf.data"
      :settings="chartConf.config"
    ></ve-pie>
  </el-card>
</template>

<script>
import VePie from "v-charts/lib/pie.common";
import mixin from "./mixin";
export default {
  name: "enquiryRegion",
  components: {
    VePie
  },
  mixins: [mixin],
  data() {
    return {
      chartConf: {
        config: {
          labelMap: {
            region: "地区",
            num: "询盘数量"
          }
        },
        data: {
          columns: ["region", "num"],
          rows: []
        }
      }
    };
  }
};
</script>

<style scoped>
</style>
